import React from 'react';
import Slider from 'react-slick';
import './slick.scss';
import './slick-theme.scss';

const ImageCarousel = ({items}) => {

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    cssEase: 'linear',
  };

  return (
    <Slider {...settings}>
      {items.map((item, k) => {
            return (
                <div className="tbcourse-template-images-item" key={`carousel-item-${k}`}>
                    <span style={{backgroundImage:`url(${item.image.fullUrl})`}}>
                        <img src={item.image.fullUrl} className='img-fluid' alt={item.image.filename}/>
                    </span>
                </div>
            );
        })}
    </Slider>
  );
};

export default ImageCarousel;
